import { match } from 'ts-pattern'
import { ScanAnalysis } from '../../utils/api-client/api-schemas.ts'
import * as styles from './analysis-status-badge.css.ts'

type AnalysisStatus = ScanAnalysis['current_state']['state']

type AnalysisStatusBadgeProps = {
  variant: AnalysisStatus
  style?: any
}

export function AnalysisStatusBadge({ variant, ...props }: AnalysisStatusBadgeProps) {
  if (variant === 'completed') return null

  const text = match(variant)
    .with('in_progress', () => 'In Progress')
    .with('failed', () => 'Failed')
    .with('queued', () => 'Queued')
    .with('skipped', () => 'Skipped')
    .exhaustive()

  return (
    <span className={styles.badge[variant as keyof typeof styles.badge]} {...props}>
      {text}
    </span>
  )
}
